import Splide from '@splidejs/splide';

const SlidersTwoColumns = () => {
    const selector = '.sliders_two_columns--left--slider .splide, .sliders_two_columns--right--slider .splide';
    const init = () => {
        var elements = document.querySelectorAll(selector);
        if (elements.length > 0) {
            Array.prototype.forEach.call(elements, function (el) {
                const splide = new Splide(el,{
                    type   : 'fade',
                    perPage: 1,
                    perMove: 1,
                    gap: '25px',
                    pagination: false,
                    heightRatio: 0.66,
                    cover: true,
                }).mount();

                splide.on('click', function () {
                    splide.go('+1');
                });
            });
        }
    };

    init();
}
export default SlidersTwoColumns;
